export default __webpack_public_path__ + "static/media/Icon.aeb04e29.svg";